import { Observable, interval, merge } from 'rxjs'
import Member from './models/Member'
import { switchMap, map, takeUntil } from 'rxjs/operators'

/**
 * Calls `updateLastSeen` and `updateLastLogin` when appropriate.
 *
 * @param currentMember$
 * @param loggedOut$
 * @param updateLastLogin
 * @param updateLastSeen
 * @param updateLastSeenInterval
 */
export function LastSeenSync(
  currentMember$: Observable<Member>,
  loggedOut$: Observable<unknown>,
  updateLastLogin: (member: Member) => Promise<unknown>,
  updateLastSeen: (member: Member) => Promise<unknown>,
  /* istanbul ignore next */
  updateLastSeenInterval = 120000,
) {
  return merge(
    currentMember$.pipe(
      takeUntil(loggedOut$),
      switchMap((m) => updateLastLogin(m)),
    ),
    currentMember$.pipe(
      // Whenever a workspace gets selected, start a timer (and stop the previous one).
      // When the timer elapses, emit the current member.
      switchMap((member) =>
        interval(updateLastSeenInterval).pipe(map(() => member)),
      ),
      takeUntil(loggedOut$),
      switchMap((m) => updateLastSeen(m)),
    ),
  )
}
